import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const deleteSurvey = async (id) => {
  const token = localStorage.getItem("token");

  const response = await axios.delete(`${__API_URL__}/api/survey/delete_survey/${id}/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useDeleteSurveyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteSurvey,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["surveys"] });
    },
    onError: (error) => {
      console.error("Failed to delete survey:", error);
    },
  });
};

export default useDeleteSurveyMutation;
